import React from "react";
import { Grid } from "semantic-ui-react";
import { CustomButton } from "../button/Button";
import "./IdleWarningModal.scss";

interface IdleWarningModalProps {
  isOpen: boolean;
  timeLeft: string;
  warningTime: number;
  onContinue: () => void;
  onLogout: () => void;
}

export const IdleWarningModal: React.FC<IdleWarningModalProps> = ({
  isOpen,
  timeLeft,
  warningTime,
  onContinue,
  onLogout
}) => {
  if (!isOpen) return null;

  return (
    <div className="idle-modal-overlay">
      <div className="idle-modal">
        <div className="idle-modal-header">
          <h3>Session Timeout Warning</h3>
        </div>

        <div className="idle-modal-body">
          <p className="idle-modal-message">
            Your session will expire due to inactivity. You will be automatically logged out in{" "}
            <span className="highlight-text">
              {warningTime} minute{warningTime !== 1 ? "s" : ""}
            </span>
            .
          </p>
          <p className="idle-modal-submessage">Click "Continue Session" to stay logged in.</p>
          <div className="countdown-timer">
            <span className="time-display">{timeLeft}</span>
          </div>
        </div>

        <div className="idle-modal-footer">
          <Grid>
            <CustomButton
              computer={8}
              tablet={8}
              mobile={16}
              theme="green"
              title="Continue Session"
              onClick={onContinue}
              customButtonStyle="idle-modal-btn"
            />
            <CustomButton
              computer={8}
              tablet={8}
              mobile={16}
              theme="red"
              title="Logout Now"
              onClick={onLogout}
              customButtonStyle="idle-modal-btn"
            />
          </Grid>
        </div>
      </div>
    </div>
  );
};
